import { useEffect, useRef } from "react";
import { handleCallback } from "../auth/authService";

export default function OidcCallback() {
    const callbackHandledRef = useRef(false);

    useEffect(() => {
        if (callbackHandledRef.current) {
            return;
        }
        callbackHandledRef.current = true;

        (async () => {
            try {
                const returnTo = await handleCallback();
                window.location.replace(returnTo);
            } catch (e: any) {
                console.error("OIDC callback failed:", e);
                window.location.replace("/");
            }
        })();
    }, []);

    return null;
}